import * as R from 'ramda';

export const filterOutNil = R.filter(R.complement(R.isNil));
